import { PHONE_NUMBER } from "../../constants/ProductConstants";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const emailAddress = "ontopcherry2025@gmail.com";
  const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(emailAddress)}`;

  return (
    <footer style={styles.footer}>

      <div style={styles.section}>
        <h4 style={styles.subtitle}>Contact Us</h4>
        <div style={styles.contactRow}>
          <span style={styles.iconWrapper}>
            {/* Email icon */}
            <svg width="18" height="18" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><rect width="20" height="16" x="2" y="4" rx="2"/><polyline points="22,6 12,13 2,6"/></svg>
          </span>
          <a
            href={gmailComposeUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.emailLink}
          >
            {emailAddress}
          </a>
        </div>
        <div style={styles.contactRow}>
          <span style={styles.iconWrapper}>
            {/* Phone icon */}
            <svg width="18" height="18" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 16.92V21a2 2 0 0 1-2.18 2A19.72 19.72 0 0 1 3 5.18 2 2 0 0 1 5 3h4.09a2 2 0 0 1 2 1.72c.13 1.13.37 2.23.72 3.28a2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6.29 6.29l1.27-1.27a2 2 0 0 1 2.11-.45c1.05.35 2.15.59 3.28.72A2 2 0 0 1 22 16.92z"/></svg>
          </span>
          <span style={styles.text}>+91 {PHONE_NUMBER}</span>
        </div>
        <div style={styles.contactRow}>
          <span style={styles.iconWrapper}>
            {/* Location icon */}
            <svg width="18" height="18" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          </span>
          <span style={styles.text}>Mission compound, Saharanpur, U.P</span>
        </div>
      </div>

      <div style={styles.linksSocialWrapper} className="footer-links-social">
        <div style={styles.sectionLinks}>
          <h4 style={styles.subtitle}>Quick Links</h4>
          <p style={styles.link} onClick={() => navigate("/")}>Home</p>
          <p style={styles.link} onClick={() => navigate("/anti-tarnish-jewellery")}>Products</p>
          <p style={styles.link} onClick={() => navigate("/faq")}>FAQ</p>
          <p style={styles.link} onClick={() => navigate("/contact")}>Contact</p>
        </div>
        <div style={styles.sectionSocial}>
          <h4 style={styles.subtitle}>Social</h4>
          <div style={styles.socialRow}>
            <a href="#" style={styles.iconLink} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              {/* Instagram icon */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C21833" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.5" y2="6.5"/></svg>
            </a>
            <a href="#" style={styles.iconLink} aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
              {/* WhatsApp icon */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true">
                <path d="M12.04 2.003a9.943 9.943 0 0 0-8.62 14.95L2 22l5.217-1.37a9.957 9.957 0 0 0 4.823 1.233h.004a9.95 9.95 0 0 0 9.95-9.95 9.944 9.944 0 0 0-2.913-7.048A9.935 9.935 0 0 0 12.04 2.003zm5.72 14.302c-.241.676-1.396 1.293-1.93 1.379-.494.078-1.12.111-1.807-.108-.417-.133-.95-.31-1.64-.607-2.886-1.247-4.773-4.153-4.918-4.35-.148-.197-1.173-1.56-1.173-2.976 0-1.417.743-2.112 1.006-2.397.263-.285.574-.356.765-.356.191 0 .383.002.551.01.177.008.414-.067.648.495.241.58.821 2.005.893 2.15.071.146.12.316.024.514-.096.198-.144.32-.287.492-.145.174-.304.388-.434.522-.145.148-.296.307-.127.603.17.295.756 1.244 1.622 2.014 1.114.99 2.055 1.296 2.35 1.443.295.148.467.127.64-.076.174-.204.742-.866.94-1.162.198-.295.398-.246.674-.148.277.099 1.758.829 2.058.979.3.148.502.222.574.345.072.124.072.718-.168 1.395z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

const styles = {
  aboutSection: {
    maxWidth: 340,
    minWidth: 220,
    marginBottom: 18,
    padding: "0 24px 8px 0",
    borderBottom: "none",
    textAlign: "left",
    flex: "0 0 340px",
    alignSelf: "flex-start"
  },
  aboutTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: "#C21833",
    margin: 0,
    letterSpacing: 0.5
  },
  aboutText: {
    fontSize: 15,
    color: "#4a5568",
    margin: "8px 0 0 0",
    lineHeight: 1.7
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    background: "#e8edf2",
    color: "#4a5568",
    padding: "40px 16px 50px 16px",
    borderTop: "1px solid rgba(0,0,0,0.1)",
    alignItems: "flex-start",
    width: "100%",
    overflowX: "hidden",
    boxSizing: "border-box", 
    marginTop:"35px"
  },
  section: { display: "flex", flexDirection: "column", gap: "14px" },
  title: { margin: 0, fontSize: "22px", color: "#C9A14A", fontWeight: 600 },
  subtitle: { margin: 0, fontSize: "16px", color: "#2d3748", fontWeight: 600 },
  text: { margin: 0, fontSize: "15px", color: "#718096" },
  emailLink: {
    margin: 0,
    fontSize: "15px",
    color: "#718096",
    textDecoration: "none",
    cursor: "pointer"
  },
  contactRow: { display: "flex", alignItems: "center", gap: "10px", marginBottom: 0 },
  iconWrapper: { display: "flex", alignItems: "center", justifyContent: "center" },
  linksSocialWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: "48px",
    alignItems: "flex-start",
    marginTop: 0,
    flexWrap: "wrap"
  },
  sectionLinks: { display: "flex", flexDirection: "column", gap: "10px", minWidth: 120 },
  sectionSocial: { display: "flex", flexDirection: "column", gap: "10px", minWidth: 120 },
  socialRow: { display: "flex", flexDirection: "row", gap: "18px", marginTop: "8px" },
  iconLink: { display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#fff", borderRadius: "50%", width: 38, height: 38, boxShadow: "0 2px 8px rgba(201,161,74,0.10)", border: "1px solid #e8edf2", textDecoration: "none", transition: "box-shadow 0.2s, transform 0.2s" },
  link: { margin: 0, fontSize: "15px", color: "#4a5568", cursor: "pointer", textDecoration: "underline", fontWeight: 500, letterSpacing: 0.2, transition: "color 0.2s" },
};

// Responsive CSS for mobile (inject as a style tag, outside the styles object)
if (typeof window !== "undefined") {
  const styleTagId = "footer-responsive-styles";
  if (!document.getElementById(styleTagId)) {
    const style = document.createElement("style");
    style.id = styleTagId;
    style.innerHTML = `
      @media (max-width: 900px) {
        footer[style] {
          flex-direction: column !important;
          gap: 18px !important;
        }
        .footer-links-social {
          flex-direction: column !important;
          gap: 18px !important;
        }
        .about-section {
          max-width: 100vw !important;
          padding-right: 0 !important;
        }
      }
      @media (max-width: 700px) {
        footer[style] {
          padding: 28px 4vw 80px 4vw !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
}